import Collection from '@/components/Collection'

export default {

  'rgp.collection': {
    path: '/admin/rgps',
    name: 'rgp.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listRGPs",
      entity: "rgp",
      cols: [
        { label: "RGP ID", field: "id", sort: "id" },
        { label: "Domain ID", field: "domain_id", sort: "domain_id" },
        { label: "Status", field: "rgp_status" },
        { label: "Elapses", field: "elapses", sort: "elapses" },
        { label: "Delete date", field: "delete_date", sort: "delete_date" },
      ],
    },
    meta: {
      title: "Registry grace period list",
      side_menu: { label: "RGPs",  icon: "hour-glass" },
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/rgp.js